import React from 'react';
import { LinkedinOutlined, TwitterOutlined } from '@ant-design/icons';
import { SocialMediaSettings } from '../AkazioConfig';
import { GoogleAnalyticsUtils, Category } from '../analytics/GoogleAnalyticsUtils';

enum SocialLinkType {
	LinkedIn = 'LinkedIn',
	Twitter = 'Twitter',
}

const ExecuteSocialLink = (linkType: SocialLinkType) => {
	let url = undefined;
	if (linkType === SocialLinkType.LinkedIn) {
		url = SocialMediaSettings.LinkedInUrl;
	} else if (linkType === SocialLinkType.Twitter) {
		url = SocialMediaSettings.TwitterUrl;
	} else {
		console.error(`Unknown link type: ${linkType}`);
		return;
	}

	window.open(url, '_blank');
	GoogleAnalyticsUtils.ReportEvent(Category.SocialLink, linkType);
};

type AkazioSocialFooterProps = {};

const AkazioSocialFooter: React.FC<AkazioSocialFooterProps> = (props) => {
	return (
		<div className="social-footer-container">
			<h4 className="social-footer-header">follow us</h4>
			<LinkedinOutlined
				className="social-footer-icon"
				onClick={() => ExecuteSocialLink(SocialLinkType.LinkedIn)}
			/>
			<TwitterOutlined className="social-footer-icon" onClick={() => ExecuteSocialLink(SocialLinkType.Twitter)} />
		</div>
	);
};

export default AkazioSocialFooter;
